import './devider.css';
const Devider = (props) => {
    return(
        <div className={`devider-${props.direction}`}></div>
    )
}
export default Devider;